import { PortableText as BasePortableText } from "@portabletext/react";
import { FC } from "react";
import clientConfig from "../../client-config";
import Figure from "./Figure";
import VideoFileBlock from "./VideoFileBlock";
import VideoYoutubeBlock from "./VideoYoutubeBlock";

const components = {
  types: {
    mainImage: Figure,
    videoFile: VideoFileBlock,
    videoYoutube: VideoYoutubeBlock,
  },
  marks: {
    link: ({ value, children }) => {
      const { href } = value;
      return (
        <a href={href} target="_blank" rel="noopener">
          {children}
        </a>
      );
    },
  },
};

interface PortableTextProps {
  blocks: any;
  className?: string;
}

const PortableText: FC<PortableTextProps> = ({ blocks, className }) => {
  return (
    <div className={className}>
      <BasePortableText
        value={blocks}
        // @ts-ignore
        components={components}
        {...clientConfig.sanity}
      />
    </div>
  );
};

export default PortableText;
